import {
  OPEN_PLAYER_BOX,
  CLOSE_PLAYER_BOX,
  MINIMIZE_PLAYER_BOX,
  MAXIMIZE_PLAYER_BOX,
  START_PLAYER,
  STOP_PLAYER,
  SHOW_PLAYER_PIP,
  HIDE_PLAYER_PIP,
  TOGGLE_PLAYER_PIP,
} from "actions/ActionTypes";

const initialState = {
  playing: false,
  playerBoxIsOpen: false,
  playerBoxIsMini: false,
  pipIsVisible: true,
  playlist_autoplay: false,
  mediaToPlay: null,
  source_from: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case OPEN_PLAYER_BOX: {
      return {
        ...state,
        playerBoxIsOpen: true,
        mediaToPlay: action.mediaToPlay,
        source_from: action.source_from,
        playerBoxIsMini: action.audio_only ? true : state.playerBoxIsMini,
        playlist_autoplay: action.playlist_autoplay,
        redirect_url: action.redirect_url,
      };
    }
    case CLOSE_PLAYER_BOX:
      return {
        ...state,
        playerBoxIsOpen: false,
        playerBoxIsMini: false,
        playlist_autoplay: false,
        mediaToPlay: null,
        source_from: null,
      };
    case MINIMIZE_PLAYER_BOX:
      return {
        ...state,
        playerBoxIsOpen: true,
        playerBoxIsMini: true,
      };
    case MAXIMIZE_PLAYER_BOX:
      return {
        ...state,
        playerBoxIsOpen: true,
        playerBoxIsMini: false,
      };
    case START_PLAYER:
      return {
        ...state,
        playing: true,
      };
    case STOP_PLAYER:
      return {
        ...state,
        playing: false,
      };
    case SHOW_PLAYER_PIP:
      return {
        ...state,
        pipIsVisible: true,
      };
    case HIDE_PLAYER_PIP:
      return {
        ...state,
        pipIsVisible: false,
      };
    case TOGGLE_PLAYER_PIP:
      return {
        ...state,
        pipIsVisible: !state.pipIsVisible,
      };
    default:
      return state;
  }
};
